import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {max} from '../../core/mathz'
import DashboardPanel from '../../core/components/DashboardPanel'
import Rating from '../../core/components/Rating'
import i18n from '../i18n'
import style from './AverageNoteDashboardPanel.less'

class AverageNoteDashboardPanel extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillMount() {
        const {campaign} = this.props

        const maxScore = campaign && max({source: campaign.notationScale, identify: (s) => s.position})
        this.setState({maxScore})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.campaign != this.props.campaign) {
            const {campaign} = nextProps

            const maxScore = campaign && max({source: campaign.notationScale, identify: (s) => s.position})
            this.setState({maxScore})
        }
    }

    render() {
        const {dispatch, authenticated, campaign, ...others} = this.props
        const {maxScore} = this.state

        const panelHeader = (title) => (
            <h4>{title}</h4>
        )

        return (
            <DashboardPanel
                header={panelHeader(i18n.averageScore)}
                onClick={authenticated.company && (() => dispatch(push('/organisations/' + authenticated.company.uid + '/satisfactioncampaigns/' + campaign.uid)))}
                {...others}>
                {!!campaign && <div className={style.defaultContent}>
                    <Rating
                        range={maxScore}
                        label={i18n.score}
                        value={campaign.stats.averageNote}/>
                </div>}
            </DashboardPanel>
        )
    }
}

AverageNoteDashboardPanel = connect((state) => ({
    authenticated: state.user.authenticated,
    campaign: state.satisfaction.campaign.campaign
}))(AverageNoteDashboardPanel)

export default AverageNoteDashboardPanel


// WEBPACK FOOTER //
// ./lib/satisfaction/components/AverageNoteDashboardPanel.js